import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import "../../../styles/admin.css";
import api from "../../../config/URL";

function FreeCashView() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`admin/freecoins/${id}`);
      setData(response.data.data);
    } catch (error) {
      toast.error("Error Fetching Data ", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [id]);

  const handleToggleStatus = async () => {
    setLoadIndicator(true);
    try {
      const res = await api.post(`admin/freecoin/status/${data.id}`);
      const { success, message } = res.data || {};
      if (success) {
        toast.success(message);
        setData((prev) => ({
          ...prev,
          is_active:
            prev.is_active === 1 || prev.is_active === "1" ? 0 : 1,
        }));
      } else {
        toast.error(message);
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
    setLoadIndicator(false);
  };

  return (
    <section className="px-4">
      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div className="card shadow border-0 mb-3">
            <div className="row p-3">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h3 className="ls-tight">Free Cash Details</h3>
                </div>
                <div className="d-flex gap-3">
                   <button
                    type="button"
                    onClick={handleToggleStatus}
                    className={`btn btn-sm me-2 ${data?.is_active === 1 || data?.is_active === "1" ? "btn-danger" : "btn-success"}`}
                    disabled={loadIndicator}
                  >
                    {loadIndicator && (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        aria-hidden="true"
                      ></span>
                    )}
                    {data?.is_active === 1 || data?.is_active === "1" ? "Deactivate" : "Activate"}
                  </button>
                  <div>
                    <Link to="/freeCash">
                      <button type="button" className="btn btn-light btn-sm">
                        <span>Back</span>
                      </button>
                    </Link>
                  </div>
                  {/* <div>
                    <Link to={`/freeCash/edit/${data.id}`}>
                      <button type="button" className="btn btn-light btn-sm">
                        <span>Edit</span>
                      </button>
                    </Link>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div
            className="container card shadow border-0"
            style={{ minHeight: "80vh" }}
          >
            <div className="row mt-5 p-3">
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Event Key</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.event_key}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Event Name</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.event_name}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Reward Amount</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : ₹
                      {data?.reward_amount}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default FreeCashView;
